const api = [
  {
    name: 'getStatisticsTop',
    method: 'GET',
    desc: '首页头部统计',
    path: '/index/getStatisticsTop'
  },
  {
    name: 'getStatisticsOrder',
    method: 'GET',
    desc: '订单统计图形',
    path: '/index/getStatisticsOrder'
  },
  {
    name: 'getStatisticsSales',
    method: 'GET',
    desc: '销售统计图形',
    path: '/index/getStatisticsSales'
  },
  {
    name: 'getStatisticsBid',
    method: 'GET',
    desc: '标书统计图形',
    path: '/index/getStatisticsBid'
  }
]

export default {
  BASE_URL: '',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/home/om.js